import { message } from 'antd';
import ipaddr from 'ipaddr.js';
import moment from 'moment-timezone';
import store from 'storejs';

import { IExplorerFilter } from '@src/emp-3.0/types';
import { EXPLORER_DIMENSION_KEYS, EXPLORER_DIMENSION_NAMES } from '@src/emp-3.0/utils/constants';

export const EventDimensions = [
  EXPLORER_DIMENSION_KEYS.REFR_URLHOST,
  EXPLORER_DIMENSION_KEYS.PAGE_URLHOST,
  EXPLORER_DIMENSION_KEYS.PAGE_URLPATH,
  EXPLORER_DIMENSION_KEYS.PAGE_URLQUERY,
  EXPLORER_DIMENSION_KEYS.REFERRER,
  EXPLORER_DIMENSION_KEYS.TITLE,
  EXPLORER_DIMENSION_KEYS.PAGE_URL,
];

export const getPayloadConfig = ({
  type,
  field,
  value,
  explorerFilter,
  startTime,
}: {
  type: 'UsersList' | 'EventList' | 'UserInfo';
  field: string;
  value: string | string[];
  explorerFilter?: IExplorerFilter;
  startTime?: string;
}) => {
  if (type === 'UsersList') {
    return {
      interval: {
        value: 5,
        unit: 'minutes',
        // for test
        // value: 1,
        // unit: 'hours',
      },
      limit: 50,
      fields: [
        EXPLORER_DIMENSION_KEYS.MAX_EVENT_TIME,
        EXPLORER_DIMENSION_KEYS.USER_ID,
        EXPLORER_DIMENSION_KEYS.CLIENT_ID,
        EXPLORER_DIMENSION_KEYS.IP_V4,
        EXPLORER_DIMENSION_KEYS.IP_V6,
        EXPLORER_DIMENSION_KEYS.APP_ID,
        EXPLORER_DIMENSION_KEYS.APPLICATION_VERSION,
        EXPLORER_DIMENSION_KEYS.DEVICE_NAME,
        EXPLORER_DIMENSION_KEYS.DA_MODEL,
        EXPLORER_DIMENSION_KEYS.BROWSER_NAME,
      ],
      filters: [field],
      filterValues: { [field]: value },
      sortBy: {
        field: [EXPLORER_DIMENSION_KEYS.MAX_EVENT_TIME],
        order: 'desc',
      },
    };
  }
  if (type === 'UserInfo') {
    const fields = [
      EXPLORER_DIMENSION_KEYS.GEO_CITY,
      EXPLORER_DIMENSION_KEYS.GEO_ZIPCODE,
      EXPLORER_DIMENSION_KEYS.APP_PLATFORM,
      EXPLORER_DIMENSION_KEYS.IP_ISP,
      EXPLORER_DIMENSION_KEYS.NET_SPEED,
      EXPLORER_DIMENSION_KEYS.IP_V4,
      EXPLORER_DIMENSION_KEYS.IP_V6,
      EXPLORER_DIMENSION_KEYS.APP_ID,
      EXPLORER_DIMENSION_KEYS.APPLICATION_VERSION,
      EXPLORER_DIMENSION_KEYS.DEVICE_NAME,
      EXPLORER_DIMENSION_KEYS.DA_MODEL,
      EXPLORER_DIMENSION_KEYS.BROWSER_NAME,
      EXPLORER_DIMENSION_KEYS.MAX_EVENT_TIME,
      EXPLORER_DIMENSION_KEYS.USER_ID,
    ];
    return {
      fields,
      interval: {
        value: 5,
        unit: 'minutes',
      },
      filters: [EXPLORER_DIMENSION_KEYS.USER_ID, EXPLORER_DIMENSION_KEYS.CLIENT_ID],
      limit: 1,
      filterValues: explorerFilter,
      sortBy: {
        field: [EXPLORER_DIMENSION_KEYS.MAX_EVENT_TIME],
        order: 'desc',
      },
    };
  }
  // this is for event list
  const fields = [
    EXPLORER_DIMENSION_KEYS.EVENT_TIME,
    EXPLORER_DIMENSION_KEYS.EVENT_TAGS,
    EXPLORER_DIMENSION_KEYS.CUSTOM_TAGS,
    EXPLORER_DIMENSION_KEYS.EVENT_NAME,
    EXPLORER_DIMENSION_KEYS.IN_SESSION,
    EXPLORER_DIMENSION_KEYS.EVENT_ID,
    // yolo custom will not show url relavant fields, filterd by backend
    ...EventDimensions,
  ];
  const interval = startTime;
  //
  const filters = [EXPLORER_DIMENSION_KEYS.USER_ID, EXPLORER_DIMENSION_KEYS.CLIENT_ID];
  return {
    fields,
    interval,
    filters,
    limit: 1000,
    filterValues: explorerFilter,
    sortBy: {
      field: [EXPLORER_DIMENSION_KEYS.EVENT_TIME, EXPLORER_DIMENSION_KEYS.EVENT_NAME],
      order: 'desc',
    },
  };
};
const validIpAndGetAddress = (ipValue) => {
  try {
    if (!ipValue) return null;
    if (ipaddr.parse(ipValue)) {
      return ipaddr.parse(ipValue);
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

export const generatePayload = (paylod) => {
  const {
    interval: intervalO,
    fields: fieldsO,
    filters: filtersO,
    sortBy,
    limit,
    filterValues,
  } = paylod;
  // only put start time here
  const interval = intervalO.value
    ? `${moment().subtract(intervalO.value, intervalO.unit).format()}`
    : intervalO;
  const fields = fieldsO.filter((x) => x !== 'ip_type');
  // if (fieldsO.includes('ip_type')) {
  //   const ipValue = filterValues['ip_type'];
  //   const ipAddress = validIpAndGetAddress(ipValue);
  //   const ip_type =
  //     ipAddress?.kind() === 'ipv4' ? EXPLORER_DIMENSION_KEYS.IP_V4 : EXPLORER_DIMENSION_KEYS.IP_V6;
  //   fields.push(ip_type);
  // }

  const filters = [
    ...filtersO.map((x) => {
      if (x === 'ip_type') {
        const ipValue = filterValues['ip_type'];
        const ipValues = Array.isArray(ipValue) ? ipValue : [ipValue];

        const filters = ipValues.map((value) => {
          const ipAddress = validIpAndGetAddress(value);
          const ip_type =
            ipAddress?.kind() === 'ipv4'
              ? EXPLORER_DIMENSION_KEYS.IP_V4
              : EXPLORER_DIMENSION_KEYS.IP_V6;

          return {
            field: ip_type,
            key: ip_type,
            op: 'eq',
            value: value,
            display: value,
            originalField: ip_type,
            _order: 0,
          };
        });

        return filters;
      }

      const values = Array.isArray(filterValues?.[x]) ? filterValues?.[x] : [filterValues?.[x]];
      return values.map((value) => {
        return {
          field: x,
          key: x,
          op: 'eq',
          value: value,
          display: value,
          originalField: x,
          _order: 0,
        };
      });
    }),
  ];
  return {
    interval,
    fields,
    filters,
    sortBy,
    limit,
  };
};

export const storeHistory = (storageName, value) => {
  const historyIPs = store.get(storageName)?.split(',').slice(0, 9) || [];
  const newItems = Array.isArray(value) ? value : [value];
  store.set(storageName, [...new Set([...newItems, ...historyIPs])].join(','));
};

export const getSummaryInfo = (summary) => {
  return [
    {
      label: 'User Info',
      items: [
        {
          label: EXPLORER_DIMENSION_NAMES.USER_ID,
          value: summary[EXPLORER_DIMENSION_KEYS.USER_ID],
        },
        {
          label: EXPLORER_DIMENSION_NAMES.GEO_CITY,
          value: summary[EXPLORER_DIMENSION_KEYS.GEO_CITY],
        },

        {
          label: EXPLORER_DIMENSION_NAMES.GEO_ZIPCODE,
          value: summary[EXPLORER_DIMENSION_KEYS.GEO_ZIPCODE],
        },
        {
          label: EXPLORER_DIMENSION_NAMES.APP_PLATFORM,
          value: summary[EXPLORER_DIMENSION_KEYS.APP_PLATFORM],
        },
        {
          label: EXPLORER_DIMENSION_NAMES.IP_ISP,
          value: summary[EXPLORER_DIMENSION_KEYS.IP_ISP],
        },

        {
          label: EXPLORER_DIMENSION_NAMES.NET_SPEED,
          value: summary[EXPLORER_DIMENSION_KEYS.NET_SPEED],
        },
        ...((summary[EXPLORER_DIMENSION_KEYS.IP_V4] || '') && [
          {
            label: EXPLORER_DIMENSION_NAMES.IP_V4,
            value: summary[EXPLORER_DIMENSION_KEYS.IP_V4],
          },
        ]),
        ...((summary[EXPLORER_DIMENSION_KEYS.IP_V6] || '') && [
          {
            label: EXPLORER_DIMENSION_NAMES.IP_V6,
            value: summary[EXPLORER_DIMENSION_KEYS.IP_V6],
          },
        ]),
        {
          label: EXPLORER_DIMENSION_NAMES.APP_ID,
          value: summary[EXPLORER_DIMENSION_KEYS.APP_ID],
        },
        {
          label: EXPLORER_DIMENSION_NAMES.APPLICATION_VERSION,
          value: summary[EXPLORER_DIMENSION_KEYS.APPLICATION_VERSION],
        },
        {
          label: EXPLORER_DIMENSION_NAMES.DEVICE_NAME,
          value: summary[EXPLORER_DIMENSION_KEYS.DEVICE_NAME],
        },
        {
          label: EXPLORER_DIMENSION_NAMES.DA_MODEL,
          value: summary[EXPLORER_DIMENSION_KEYS.DA_MODEL],
        },
        {
          label: EXPLORER_DIMENSION_NAMES.BROWSER_NAME,
          value: summary[EXPLORER_DIMENSION_KEYS.BROWSER_NAME],
        },
      ],
    },
  ];
};
